import { Button, Switch, Card, List, Text } from "../../../../components";
import Localization from "../../../../localization";
import { Flex } from "antd";
import React from "react";

const Webhook = ({
  webhook,
  onLearnMore = () => {},
  configureWebhook = () => {},
  toggleActivation = () => {},
  title = Localization.general.smhi,
  ...props
}) => {
  const renderItem = (_) => {
    const active = !!_?.enabled;
    const color = active ? "secondary" : "disabledDark";

    return (
      <List.Item
        children={
          <div className="w-100">
            <Flex flex={1} align="center" justify="space-between">
              <Text
                weight={700}
                type={color}
                style={{ width: "40rem" }}
                ellipsis={{ tooltip: _?.url }}
              >
                {`${_?.method?.toUpperCase()}: `}
                <Text
                  type={color}
                  weight={500}
                  level={"text"}
                  children={_?.url}
                />
              </Text>
              <Switch checked={active} onChange={() => toggleActivation(_)} />
            </Flex>
            {!!_?.body && (
              <div
                style={{
                  maxHeight: "24rem",
                  marginTop: "1.2rem",
                  overflowY: "auto",
                  overflowX: "hidden",
                }}
              >
                <Text
                  type={color}
                  weight={500}
                  children={_.body}
                  whiteSpace="pre-line"
                />
              </div>
            )}
          </div>
        }
      />
    );
  };

  return (
    <Card {...props} title={title}>
      <Text weight={400} type="secondary">
        {!!webhook?.url && !webhook.enabled && (
          <Text
            weight={600}
            level={"link"}
            type="secondary"
            children={Localization.general.inactive + ": "}
          />
        )}
        {!webhook?.url
          ? Localization.service.smhi_webhook_empty_desc
          : Localization.service.smhi_webhook_desc}
      </Text>
      {!!webhook?.url && (
        <List
          className="m-30-t"
          dataSource={[webhook]}
          rowKey={(_) => _ + ""}
          highlightOnHover={false}
          renderItem={renderItem}
        />
      )}
      <Flex gap={"1rem"} className="m-35-t" wrap="wrap">
        {React.Children.toArray(
          [
            !webhook?.url
              ? {
                  onClick: () =>
                    configureWebhook({ ...webhook, enabled: true }),
                  title: Localization.general.add_new_integration,
                }
              : {
                  onClick: () => configureWebhook(webhook),
                  title: Localization.general.edit_integration,
                },
            { title: Localization.general.learn_more, onClick: onLearnMore },
          ]
            .filter(Boolean)
            .map((button, index) => (
              <Button {...button} type={!index && "primary"} />
            ))
        )}
      </Flex>
    </Card>
  );
};

export default Webhook;
